import React from "react";
import { isRecorderMode, isRenderMode } from "../utils/recorderMode";

// Single recorder-leak gate: ALL new chrome mounts under this component.
export default function VisorChrome({ children, className = "" }) {
  if (isRecorderMode() || isRenderMode()) return null;
  return <div className={`vchrome ${className}`.trim()}>{children}</div>;
}
